import AdvancedSecurityOptionFull from './components/AdvancedSecurityOptionFull';
import * as React from 'react';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import { getUserConfiguration } from 'owa-session-store';
var AdvancedSecurityOption = {
    key: 'advancedSecurity_',
    titleStringKey: 'optionTitle_premium_advanced_security',
    searchTermsStringKey: 'optionTitle_premium_advanced_security',
    hideTitleInFullOptions: false,
    fullOptionFormSettings: {
        render: function () { return React.createElement(AdvancedSecurityOptionFull, null); },
        isDirty: function () { return false; },
        onSave: null,
        onDiscard: null,
        hideSaveDiscard: function () { return true; },
    },
    isHidden: function () {
        return !isControlFeatureEnabled('auth-PremiumDashboardApril') ||
            !getUserConfiguration().SessionSettings.IsPremiumConsumerMailbox;
    },
};
export default AdvancedSecurityOption;
//# sourceMappingURL=AdvancedSecurityOption.js.map